// extracted by mini-css-extract-plugin
export var discard = "_4x-3";
export var muiTooltipTooltip = "_4x-5";
export var notificationBar = "_4x-2";
export var saveButtonHoverSlotWrapper = "_4x-4";
export var show = "_4x-1";
export var spacer = "_4x-0";